<script setup lang="ts">
import { CircleCheck, CircleX, Info, X } from '@lucide/vue'
import { useToast } from '@/composables/useToast'

const { toasts, dismiss } = useToast()
</script>

<template>
    <Teleport to="body">
        <div class="pointer-events-none fixed inset-x-4 top-4 z-[100] flex flex-col items-center gap-2 sm:left-auto sm:w-96">
            <TransitionGroup name="toast">
                <div
                    v-for="toast in toasts"
                    :key="toast.id"
                    class="pointer-events-auto w-full flex items-center gap-3 glass-panel rounded-xl px-4 py-3 text-sm text-[var(--c-text)]"
                >
                    <CircleCheck v-if="toast.tone === 'success'" class="size-5 shrink-0 text-emerald-400" />
                    <CircleX v-else-if="toast.tone === 'error'" class="size-5 shrink-0 text-rose-400" />
                    <Info v-else class="text-cyan-400 size-5 shrink-0" />
                    <span class="min-w-0 flex-1">{{ toast.message }}</span>
                    <button class="rounded-lg p-1 text-[var(--c-text-muted)] hover:text-[var(--c-text)] focus-ring" aria-label="关闭提示" @click="dismiss(toast.id)">
                        <X class="size-4" />
                    </button>
                </div>
            </TransitionGroup>
        </div>
    </Teleport>
</template>

<style scoped>
.toast-enter-active,
.toast-leave-active {
    transition:
        opacity 180ms ease,
        transform 180ms ease;
}
.toast-enter-from,
.toast-leave-to {
    opacity: 0;
    transform: translateY(-10px) scale(0.98);
}
</style>
